import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { PageHeader, CustomPanel, CustomDropdown } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalGrupoProduto from './ModalGrupoProduto'
import GrupoProdutoHttp from '../../../../services/api/https/registration/grupo-produto.http'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'

const GrupoProdutos = ({ history, dispatch }) => {
  // Hooks
  const [empresaSelecionada, setEmpresaSelecionada] = useState('')
  const [empresas, setEmpresas] = useState([])
  const [grupos, setGrupos] = useState([])
  const [grupoSelecionado, setGrupoSelecionado] = useState(null)

  useEffect(() => {
    async function fetchGrupos(empresa_id) {
      try {
        dispatch(showLoadingBox('Carregando os Grupos de Produtos . . . ', 'Aguarde'))
        const _grupos = await GrupoProdutoHttp.getGrupos(empresa_id)
        setGrupos(_grupos)
      } catch (error) {
        dispatch(showMessageBox(null, errorHandler(error)))
      } finally {
        dispatch(hideLoadingBox())
      }
    }
    if (typeof empresaSelecionada !== 'string') {
      fetchGrupos(empresaSelecionada.empresa_id)
    }
  }, [empresaSelecionada])

  useEffect(() => {
    if (empresas.length === 0) {
      const _empresas = getEmpresas()
      const savedEmpresas = Array.isArray(_empresas)
        ? _empresas.map(e => ({ empresa_id: e.id, empresa_nome: e.name }))
        : []
      setEmpresas(savedEmpresas)
    }
  }, [])

  // Events
  const onEmpresaChange = empresa => {
    if (typeof empresa !== 'string') {
      setEmpresaSelecionada(empresa)
    }
  }
  const onSalvarGrupo = async grupo => {
    try {
      dispatch(showLoadingBox('Salvando Grupo . . .', 'Aguarde'))
      const savedGrupo = await GrupoProdutoHttp.salvarGrupo(grupo, empresaSelecionada.empresa_id)
      setGrupos(prevState => {
        const index = prevState.findIndex(p => p.id === savedGrupo.id)
        if (index !== -1) {
          prevState[index] = savedGrupo
        } else {
          prevState.push(savedGrupo)
        }
        return [...prevState]
      })
      setGrupoSelecionado(null)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  // Render
  return (
    <>
      <PageHeader>2.3 - Grupo de Produtos</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => setGrupoSelecionado({ id: null, nome: '' })}
          onVoltar={history.goBack}
        >
          <div className="p-row">
            <div className="p-col-3">
              <CustomDropdown
                showLabel={true}
                filter={true}
                label="Selecione Empresa"
                marginTop={0}
                optionLabel="empresa_nome"
                options={empresas}
                value={empresaSelecionada}
                onChange={onEmpresaChange}
              />
            </div>
            <div className="p-col-12">
              <DataTable
                value={grupos}
                emptyMessage="Nenhum Grupo de Produtos associado a esta empresa"
                selectionMode="single"
                onSelectionChange={item => setGrupoSelecionado(item.value)}
              >
                <Column field="id" header="Código" style={tableCellCentered(70)} />
                <Column field="nome" header="Grupo" />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalGrupoProduto
        incomeGrupo={grupoSelecionado}
        onResponse={(action, payload) => {
          if (action === 'CLOSE') setGrupoSelecionado(null)
          if (action === 'SALVAR') onSalvarGrupo(payload)
        }}
      />
    </>
  )
}

export default connect()(withRouter(GrupoProdutos))
